// test1089
(1089 && 0);
